import { useQuery } from 'react-query';
import { ENTITY } from '../constants';
import { SubRegionApi } from '../apis';

type QueryData = {
  id: number;
  name: {
    uz: string;
    oz: string;
    ru: string;
    en: string;
  };
};

const useRegion = ({ region_id }: { region_id: number }) => {
  return useQuery<QueryData[], Error, QueryData[]>({
    queryKey: [ENTITY, 'sub-region', region_id],
    async queryFn() {
      const { data } = await SubRegionApi({ region_id });
      return data.data;
    },
    initialData: [],
    retry: false,
    enabled: !!region_id
  });
};

export default useRegion;
